import { PropsWithChildren } from 'react';
import './DataListHeader.scss';
// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {};

const DataListHeader = ({ children }: PropsWithChildren<Props>): JSX.Element => (
  <div className="table__top-wrap">{children}</div>);

export default DataListHeader;
